import * as types from '../actions/actionTypes';
import { updateStatuses } from '../statuses';
import config from '../serverApi/config.js';
import $ from 'jquery';
import 'ms-signalr-client';

export function startNotificationActionCreator(store) {
    const maxDelay = 60000;
    const initialDelay = 2000;
    let delay = initialDelay;

    const connection = $.hubConnection(config.baseAddress);
    const messages = connection.createHubProxy('clientHub');
    messages.on('broadcastMessage', message =>
        //toUpperCase avoids awkward interplay between StringEnumConverter and FilteredCamelCaseConverter - there's a comment in actionTypes to try to make this more obvious
        store.dispatch({ type: message.type.toUpperCase(), updateStatus: updateStatuses.success, value: message.update })
    );

    connection.error(console.log);

    connection.stateChanged(state => {
        if (state.newState !== $.signalR.connectionState.connecting) {
            const connected = state.newState === $.signalR.connectionState.connected;
            delay = connected ? initialDelay : Math.min(maxDelay, delay * 2); //Back off on failure
            store.dispatch({ type: connected ? types.APP_INITIATED : types.APP_DISCONNECTED });
        }
    });

    connection.disconnected(() => 
        setTimeout(() => connection.start(), delay)
    );

	// Disable SignalR for demo
    //connection.start();
}


// WEBPACK FOOTER //
// ./src/js/actions/externallyTriggeredActionCreators.js